import React, { Component } from "react"
import { Link } from "gatsby"
import t from "../../../locale"
import baker from "../../images/baker.jpg"
import baker2 from "../../images/baker2.jpg"

import "./Welcome.scss"

class Welcome extends Component {
  render() {
    return (
      <section id="welcome">
        { typeof t === "function" ?
          <div className="container height-helper">
            <div className="row height-helper">
              <div className="col-md-6 welcome-left">
                <h4 className="welcome-subhead">
                  {t("welcomeSubheader")}
                </h4>
                <h1 className="welcome-header">
                  <span>artic</span> BAKEHOUSE
                </h1>
                <p className="welcome-text">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent vestibulum ex at tortor molestie.
                </p>
                <p className="welcome-text">
                  Lorem ipsum dolor sit amet, consectetur adipiscing elit. Praesent vestibulum ex at tortor molestie, ut
                  lacinia nunc fringilla. Nulla id arcu id urna sodales efficitur.Lorem ipsum dolor sit amet,
                  consectetur
                  adipiscing elit. Praesent vestibulum ex at tortor molestie, ut lacinia nunc fringilla.
                  <br/>
                  And if you want to become part of our <span className="welcome-artic-span">artic</span> family, feel free to
                    <Link className="welcome-link" to="/contact">
                      JOIN US.
                    </Link>
                </p>
              </div>
              <div className="col-md-6  welcome-right">
                <img className="welcome-img img1" src={baker} alt="articBakehouse baker"/>
                <img className="welcome-img img2" src={baker2} alt="articBakehouse baker2"/>
              </div>
            </div>
          </div>
        : null}
      </section>
    )
  }
}

export default Welcome